var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7015 5.00188C2.34929 4.97498 2 5.23954 2 5.63892V15.3132H22V14.9542C22 13.2969 20.8292 11.862 19.1837 11.5025L18.0294 11.2503C16.7263 10.9656 15.4785 10.5091 14.3169 9.89965L12.9445 11.2489C11.8706 12.3048 10.1294 12.3048 9.05546 11.2489L2.7015 5.00188Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3186 7.81246C11.166 7.67495 11.0163 7.53413 10.8695 7.39007L10.5304 7.72346C10.2375 8.01142 9.76261 8.01142 9.46972 7.72346C9.17683 7.43549 9.17683 6.96861 9.46972 6.68065L9.86242 6.29455C9.83533 6.26185 9.80837 6.22902 9.78156 6.19606L9.64848 6.03251C9.27516 5.57372 8.61768 5.45044 8.09882 5.74194C7.4844 6.08713 6.80911 6.26791 6.13293 6.28989L10.1162 10.2061C10.6044 10.686 11.3958 10.686 11.884 10.2061L12.9941 9.11467C12.8203 8.99878 12.6489 8.8792 12.4802 8.75598L12.0304 9.19821C11.7375 9.48617 11.2627 9.48617 10.9698 9.19821C10.6769 8.91025 10.6769 8.44337 10.9698 8.1554L11.3186 7.81246Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.0337H22V18.0168C22 18.5598 21.5523 19 21 19H3C2.44772 19 2 18.5598 2 18.0168V17.0337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoe);
export default __webpack_public_path__ + "static/media/shoe.0add1442ffc5edef6b3e39f8ee60a077.svg";
export { ForwardRef as ReactComponent };